import { configureStore } from "@reduxjs/toolkit";
import _routes from "./_routes";

const model = configureStore({
    reducer : _routes
})

export default model;